var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullscreenclose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1917_8773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 15H13.5C12.6716 15 12 15.6716 12 16.5V33.5C12 34.3284 12.6716 35 13.5 35H36.5C37.3284 35 38 34.3284 38 33.5V16.5C38 15.6716 37.3284 15 36.5 15Z",
    stroke: "#BBB6B6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9816 25.0179L21.9756 26.0179L22.9756 26.0239L22.9816 25.0239L21.9816 25.0179ZM16.7293 18.279C16.3412 17.8861 15.708 17.8823 15.3152 18.2704C14.9223 18.6586 14.9185 19.2917 15.3066 19.6846L16.7293 18.279ZM21.0179 19.012L20.9817 25.0119L22.9816 25.0239L23.0179 19.0241L21.0179 19.012ZM21.9877 24.0179L15.9878 23.9817L15.9757 25.9817L21.9756 26.0179L21.9877 24.0179ZM22.693 24.3151L16.7293 18.279L15.3066 19.6846L21.2703 25.7207L22.693 24.3151Z",
    fill: "#BBB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0261 24.974L28.0347 23.974L27.0348 23.9654L27.0261 24.9654L28.0261 24.974ZM33.2609 31.7266C33.648 32.1204 34.2811 32.1259 34.675 31.7388C35.0689 31.3517 35.0743 30.7185 34.6872 30.3246L33.2609 31.7266ZM28.9742 30.9824L29.0261 24.9826L27.0261 24.9654L26.9743 30.9651L28.9742 30.9824ZM28.0175 25.974L34.0172 26.0258L34.0345 24.0259L28.0347 23.974L28.0175 25.974ZM27.3129 25.675L33.2609 31.7266L34.6872 30.3246L28.7393 24.273L27.3129 25.675Z",
    fill: "#BBB6B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1917_8773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenclose);
export default __webpack_public_path__ + "static/media/fullscreenclose.42d2ab4c173887933a28700e3278b75e.svg";
export { ForwardRef as ReactComponent };